import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { DesireSection } from './components/DesireSection';
import { ProductIntro } from './components/ProductIntro';
import { TruthSection } from './components/TruthSection';
import { TableOfContents } from './components/TableOfContents';
import { SixtyDayPlan } from './components/SixtyDayPlan';
import { ForWhom } from './components/ForWhom';
import { Results } from './components/Results';
import { PricingOffer } from './components/PricingOffer';
import { Guarantee } from './components/Guarantee';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-gradient-dark text-slate-300 font-body selection:bg-gold-500/30 selection:text-white" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />

        <div className="container mx-auto px-4" data-id="element-3">
          <div className="section-divider" data-id="element-4" />
        </div>

        <PainPoints data-id="element-5" />
        <DesireSection data-id="element-6" />

        <div className="container mx-auto px-4" data-id="element-7">
          <div className="section-divider" data-id="element-8" />
        </div>

        <ProductIntro data-id="element-9" />
        <TruthSection data-id="element-10" />

        <div className="container mx-auto px-4" data-id="element-11">
          <div className="section-divider" data-id="element-12" />
        </div>

        <TableOfContents data-id="element-13" />
        <SixtyDayPlan data-id="element-14" />

        <div className="container mx-auto px-4" data-id="element-15">
          <div className="section-divider" data-id="element-16" />
        </div>

        <ForWhom data-id="element-17" />
        <Results data-id="element-18" />

        <div className="container mx-auto px-4" data-id="element-19">
          <div className="section-divider" data-id="element-20" />
        </div>

        <PricingOffer data-id="element-21" />
        <Guarantee data-id="element-22" />
        <FinalCTA data-id="element-23" />
      </main>

      <Footer data-id="element-24" />
    </div>;
}